import { companyService } from 'hq/services';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { CompanyUpdateData } from '@types';

type CompanyMutationOptions = UseMutationOptions<unknown, unknown, CompanyUpdateData>;

export const useUpdateCompany = (companyId: string) => {
  const mutationFn = async (payload: CompanyUpdateData) => {
    await companyService.updateCompany(companyId, payload);
  };
  const queryClient = useQueryClient();
  const mutationOptions: CompanyMutationOptions = {
    onSuccess: async () => {
      await Promise.all([queryClient.invalidateQueries(QUERY_KEYS.companies())]);
    },
  };

  return useMutation(mutationFn, mutationOptions);
};
